import { useState, useEffect, useCallback } from "react";
import { SidebarActions } from "@/components/layout/SidebarActions";
import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { PromptLabelList } from "@/components/flow/build/Steps/Prompt/SidebarContent/PromptLabel/PromptLabelList";
import { GeneratePredictions } from "@/components/flow/build/Steps/Prompt/SidebarContent/Annotate/GeneratePredictions";
import { DEFAULT_CHILD_ANIMATION_DELAY, DEFAULT_DURATION } from "@/constants/motion";
import { BuildPromptSteps } from "@/types/flows";
import { useApprovedCount, useTotalBatchCount } from "@/store";
import { ApproveImageBtn } from "./ApproveImageBtn";
import { ReviewTipsCard } from "@/components/tutorial/ReviewTipsCard";

export function ImproveSidebarContent() {
    const approvedCount = useApprovedCount();
    const totalBatchCount = useTotalBatchCount();

    const [showCTAs, setShowCTAs] = useState(false);
    const [showReviewTips, setShowReviewTips] = useState(false);
    const [helpAnchor, setHelpAnchor] = useState<HTMLElement | null>(null);

    // Show CTAs after parent animation completes
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowCTAs(true);
        }, DEFAULT_CHILD_ANIMATION_DELAY);

        return () => clearTimeout(timer);
    }, []);

    const headerTitle = "How do the objects look?";

    const handleHelpClick = useCallback((anchorElement: HTMLElement) => {
        setHelpAnchor(anchorElement);
        setShowReviewTips((prev) => !prev);
    }, []);

    const handleCloseReviewTips = useCallback(() => {
        setShowReviewTips(false);
    }, []);

    return (
        <>
            <SidebarHeader
                title={headerTitle}
                description="Review and edit the boxes until they look good for you."
                showImageCountChip
                currentImageCount={approvedCount}
                totalImagesNeeded={totalBatchCount}
                onHelpClick={handleHelpClick}
            />
            <div className="content">
                <GeneratePredictions />
                <PromptLabelList mode={BuildPromptSteps.ANNOTATE_DATA} />
            </div>
            <SidebarActions
                toolbarProps={{
                    initial: { opacity: 0 },
                    animate: { opacity: showCTAs ? 1 : 0 },
                    transition: { duration: DEFAULT_DURATION.slower, ease: "easeOut" }
                }}
            >
                <ApproveImageBtn />
            </SidebarActions>
            {/* 
TODO: Add review tips card  back when we have a good reason to
            <ReviewTipsCard
                isOpen={showReviewTips}
                onClose={handleCloseReviewTips}
                anchorElement={helpAnchor}
            /> */}
        </>
    );
}
